import { SubTitle } from '../comm';
import AboutQualification from './AboutQualification';
import AboutRange from './AboutRange';
import Page from '@/components/comm/Page';
import PageTitle from '@/components/comm/PageTitle';
import Tabs, { normalTabHeadStyle } from '@/components/comm/tabs';
import Tab from '@/components/comm/tabs/Tab';
import { useImmediateHackleTrack } from '@/lib/hackle.service';
import { useRouteChangeTab } from '@/lib/use-route-change-tab';

const pageTitle = 'PCCE(코딩필수역량인증)';

const aboutPcceTabInfo = Object.freeze({
  qualification: 0,
  range: 1,
});

const Pcce: NextPageWithAppProps = () => {
  useImmediateHackleTrack({
    event: {
      key: 'certi_pcce_viewed',
    },
  });

  const {
    selectedTabIndex,
    handleRouteChangeTab,
  } = useRouteChangeTab(aboutPcceTabInfo);

  return (
    <Page>
      <PageTitle title={pageTitle}>
        <SubTitle>Programmers Certified Coding Essential</SubTitle>
      </PageTitle>
      <Tabs
        index={selectedTabIndex}
        headStyle={normalTabHeadStyle}
        onChange={handleRouteChangeTab}
      >
        <Tab
          tabIndex={aboutPcceTabInfo.qualification}
          tabTitle="응시 자격 및 시험 안내"
        >
          <AboutQualification />
        </Tab>
        <Tab
          tabIndex={aboutPcceTabInfo.range}
          tabTitle="출제 범위와 합격 기준"
        >
          <AboutRange />
        </Tab>
      </Tabs>
    </Page>
  );
};

export default Pcce;

Pcce.getPageProps = () => ({
  pageTitle,
});
